import React, { FC } from 'react';

import shuffleArray from 'crehana-utils/shuffleArray';

// eslint-disable-next-line no-restricted-imports
import { useTranslation } from '@crehana/i18n';

import { SOCIAL_NOTIFICATION_USERS as users } from 'Jsx/Shared/Hooks/useTrustPulseNotification/constants';

import { NotificationUser } from 'Jsx/CheckoutV4/types';

const SocialNotification: FC<{
  className?: string;
  imageClassName?: string;
}> = ({ className, imageClassName }) => {
  const { t } = useTranslation();
  const [notificationMessage, setNotificationMessage] =
    React.useState<string>('');
  const [notificationUser, setNotificationUser] =
    React.useState<NotificationUser | undefined>(undefined);

  React.useEffect(() => {
    if (notificationUser) {
      const randomNumber = Math.floor(Math.random() * 7 + 1) + 2;

      const message = t('USERPROOF_LABEL', {
        interpolation: {
          userQuantity: randomNumber,
          countryName: notificationUser.city,
        },
      });

      setNotificationMessage(message);
    }
  }, [notificationUser]);

  React.useEffect(() => {
    shuffleArray(users).forEach(user => {
      setNotificationUser(user);
    });
  }, []);

  if (!notificationMessage) return null;

  return (
    <p
      className={`flex items-center p-16 bg-white w-auto ${className}`}
      style={{ borderRadius: 10, width: 'fit-content' }}
    >
      <img
        src={notificationUser?.image}
        alt={notificationUser?.city}
        className={`h-auto mr-16 ${imageClassName}`}
      />
      <span className="font-body3">{notificationMessage}</span>
    </p>
  );
};

export default SocialNotification;
